import { IListOptionsFilter } from "./base";

export interface IOrderTaskMapListFilter extends IListOptionsFilter {
orderTaskNumbers: string[];
}
